import { useAppSelector } from './hooks';
import { useEffect, useState } from 'react';
import { UserProfile } from 'oidc-client-ts';
import { ADMIN_ROLE, SUPER_ADMIN_ROLE } from '../constants';
import authService from '../services/AuthService';

export function useCurrentUser(): [boolean, boolean, UserProfile | null] {
    const currentUser = useAppSelector(s => s.currentUser);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [isTenantAdmin, setIsTenantAdmin] = useState<boolean>(false);
    const [currentUserData, setCurrentUserData] = useState<UserProfile | null>(null);

    useEffect(() => {
        const initCurrentUser = async () => {
            const user = await authService.getUser();
            const roles: string[] = user?.profile?.role
                ? Array.isArray(user.profile.role)
                    ? user.profile.role
                    : [user.profile.role]
                : [];
            const isAdminValue = roles ? roles.indexOf(ADMIN_ROLE) > -1 : false;
            const isSuperAdminValue = roles ? roles.indexOf(SUPER_ADMIN_ROLE) > -1 : false;
            setIsAdmin(isAdminValue || isSuperAdminValue);
            setIsTenantAdmin(currentUser.data?.isTenantAdmin === true);
            setCurrentUserData(user?.profile !== undefined ? user?.profile : null);
        };
        initCurrentUser();
    }, [currentUser, currentUser.data]);

    return [isAdmin, isTenantAdmin, currentUserData];
}
